module.exports = new __parcel__URL__("project-settings-features-app-skeleton.tpl.b8e7f249.svg").toString();